
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1i2wg_r305c_17",
  "dismiss-button": "awsui_dismiss-button_1i2wg_r305c_49",
  "dismiss-button-inline": "awsui_dismiss-button-inline_1i2wg_r305c_90",
  "icon": "awsui_icon_1i2wg_r305c_100",
  "icon-inline": "awsui_icon-inline_1i2wg_r305c_106",
  "token-normal": "awsui_token-normal_1i2wg_r305c_111",
  "token-inline": "awsui_token-inline_1i2wg_r305c_118",
  "token-option-inline": "awsui_token-option-inline_1i2wg_r305c_144",
  "token-box": "awsui_token-box_1i2wg_r305c_148",
  "token-box-without-dismiss": "awsui_token-box-without-dismiss_1i2wg_r305c_167",
  "token-box-inline": "awsui_token-box-inline_1i2wg_r305c_171",
  "disable-padding": "awsui_disable-padding_1i2wg_r305c_191",
  "token-box-readonly": "awsui_token-box-readonly_1i2wg_r305c_198",
  "token-box-disabled": "awsui_token-box-disabled_1i2wg_r305c_199"
};
  